import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import VaSelectOptionList from './VaSelectOptionList.vue'

export default withConfigTransport(VaSelectOptionList)
